import {Component, Input, OnInit} from '@angular/core';
import {MESSAGES} from '@app/core/model/messages';

@Component({
    selector: 'ngc-data-error',
    templateUrl: './data-error.component.html',
    styleUrls: ['./data-error.component.scss']
})
export class DataErrorComponent implements OnInit {

    @Input() errorMessage: string;
    @Input() errorMessage2: string;
    @Input() linkTitle: string;
    @Input() link: string;
    @Input() greyColor: boolean;

    constructor() { }

    ngOnInit() {
        if (!this.errorMessage) {
            this.errorMessage = MESSAGES.DATA_LOADING_ERROR;
        }
    }

}
